const SHOW_CREDIT_CARD_PAYMENT_METHODS = false;

import { useAuth } from "@/providers/auth";
import { usePaymentMethods } from "@/queries/payment-method/use-payment-methods";
import { PaymentMethodCard } from "./payment-method-card";
import { CreditCardPaymentMethodCard } from "./credit-card-payment-method-card";
import { PlaidLinkCard } from "./plaid-link-card";
import { Skeleton } from "../ui/skeleton";

export default function PaymentMethodList() {
  const { cognitoId, clientId, userRole } = useAuth();
  const isAdmin = userRole === "admin";
  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const paymentMethodsQuery = usePaymentMethods(userId);

  const plaidMethods = paymentMethodsQuery.data?.filter(
    (pm) => pm.payment_method_type === "PLAID"
  );
  const ccMethods = paymentMethodsQuery.data?.filter(
    (pm) => pm.account_type === "Credit Card"
  );

  return (
    <div className="flex flex-wrap gap-4">
      {paymentMethodsQuery.isLoading ? (
        <Skeleton className="w-[370px] h-72 rounded-xl bg-gray-200/80" />
      ) : (
        <>
          {plaidMethods?.map((pm) => (
            <PaymentMethodCard paymentMethod={pm} key={pm.payment_method_id} isAdmin={isAdmin} />
          ))}
          {SHOW_CREDIT_CARD_PAYMENT_METHODS && ccMethods?.map((pm) => (
            <CreditCardPaymentMethodCard paymentMethod={pm} key={pm.payment_method_id} />
          ))}
        </>
      )}
      {!isAdmin && <PlaidLinkCard />}
    </div>
  );
}
